import React from 'react'
import { ApplicationLoader } from './application-loader'
import { ApplicationLoaderPublicProps } from '.'
import { Application } from '../applications-grid/shared'

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {}

export const ApplicationLoaderCacheOnly = ({
  organizationID,
  applicationID,
  children
}: ApplicationLoaderPublicProps & {
  readonly children: (application: Application) => React.ReactNode
}) => (
  <ApplicationLoader
    organizationID={organizationID}
    applicationID={applicationID}
    fetchPolicy="cache-only"
    renderLoading={noop}
    renderLoaded={children}
  />
)
